module.exports = __webpack_public_path__ + "img/pending_zone_selected.9ddb5be4.svg";